import { IBidderGroup } from '~/src/dash/api/bidder-group';
import { IAdserverCampaign } from '~/src/dash/api/campaign/campaign';
import { ISmallSite } from '~/src/dash/api/channels/channels_models';
import {
  IChannelGroup,
  IChannelLabel,
  IChannelList,
  IHeaderBidder,
} from '~/src/dash/api/console-api';
import { IDeal } from '~/src/dash/api/deals';

export interface IListItem {
  title: string;
  selected: boolean;
  ID: string;
  description?: string;
  site?: ISmallSite;
  small_site?: ISmallSite;
  hb?: IHeaderBidder;
  siteIDs?: string[];
  siteID?: string;
  campaign?: IAdserverCampaign;
  channelGroup?: IChannelGroup;
  channelList?: IChannelList;
  bidderGroup?: IBidderGroup;
  channelLabel?: IChannelLabel;
  deal?: IDeal;
  // graphType and yAxisID used for live data graph
  graphType?: string;
  yAxisId?: string;
  // defaultWeight used for line item site weights (Premion only, HB-2385)
  defaultWeight?: number;
  bidderID?: string;
  uiBidderType?: boolean;
  originalValueSelected?: boolean;
  disabled?: boolean;
  uuid?: string;
  abbrevTitle?: string;
  object?: any;
  active?: boolean;
  advertiserID?: number;
  paramString?: string;
  values?: string[];
  orderID?: number;
  value?: number;
  subheader?: string;
  // mimeType used for distinguishing between video and image creatives
  mimeType?: string;
  bidderIDs?: number[];
  isCustom?: boolean;
  isDisabled?: boolean;
}

export interface IMenuList {
  [key: string]: IListItem;
}

/**
 * Return the list of keys of selected elements /!\ NOT IDS, list of KEYS
 * @param list
 */
export function FindSelectedFromMenuList(list: IMenuList): string[] {
  const selected = [] as string[];
  Object.keys(list).forEach((value: string) => {
    if (list[value].selected) {
      selected.push(value);
    }
  });
  return selected;
}

/**
 * Return the list of ids of the selected elements
 * @param list
 */
export function FindSelectedIDsFromMenuList(list: IMenuList): string[] {
  const selectedIDs = [] as string[];
  Object.keys(list).forEach((value: string) => {
    if (list[value].selected) {
      selectedIDs.push(list[value].ID);
    }
  });
  return selectedIDs;
}

export function getNumSelectedFromIMenuList(list: IMenuList): number {
  return FindSelectedIDsFromMenuList(list).length;
}
